export const FIELD_LABELS = {
    mode: "Mode",
    method: "Method",
    filename: "Event ID",
    trigtime: "Event Time (Fermi MET)",
    trigutc: "Event Time (UTC)",
    duration: "Duration",
    hr_25: "HR 25",
    hr_50: "HR 50",
    hr_75: "HR 75",
    event_grade: "Event Grade",
    saa: "SAA",
    sgr: "SGR",
    sgrb: "SGRB (Short GRB)",
    lgrb: "LGRB (Long GRB)",
    sflare: "SFLARE",
    tgf: "TGF",
    transnt: "TRANSNT",
    distpar: "DISTPAR",
    loclpar: "LOCLPAR",
    no_evaluation: "UNKNOWN",
    sig_min: "Significance Minimum",
    sig_max: "Significance Maximum",
    event_class: "Event Class",
    l_shell: "L SHELL",
    latitude: "Latitude",
    longitude: "Longitude",
    ratio: "Ratio",
    tres: "Time Resolution",
    min_eng: "E Min",
    max_eng: "E Max",
    filtering_classes: "Filter Class",
    filtering_grades: "Filter Grades",
    filtering_ids: "Filter ID",
    trigdets: "Trig Dets",
    class_probability: "Class Prob",
    class_array: "Class Array",
}

export enum FIELD {
    TRIGTIME = "trigtime",
    TRIGUTC = "trigutc",
    DURATION = "duration",
    HR_25 = "hr_25",
    HR_50 = "hr_50",
    HR_75 = "hr_75",
    EVENT_GRADE = "event_grade",
    SAA = "saa",
    SGR = "sgr",
    SGRB = "sgrb",
    LGRB = "lgrb",
    SFLARE = "sflare",
    TGF = "tgf",
    TRANSNT = "transnt",
    DISTPAR = "distpar",
    LOCLPAR = "loclpar",
    NO_EVALUATION = "no_evaluation",
    SIG_MIN = "sig_min",
    SIG_MAX = "sig_max",
}



export enum FTYPE {
    PDF = ".pdf",
    JSON = ".json"
}

export const DATA_PATH = "tmp/";

export enum EVALUE {
    MIN = "min",
    MAX = "max"
}

const BASES = {
    // DEV: "http://localhost",
     DEV: "https://magnetars.sabanciuniv.edu",
    // DEV: "http://magnetars.sabanciuniv.edu",
    PRD: ""
}

export const BASE = BASES.DEV;